import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _Company } from '../../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}
export const SelectAccountantIDLevelConstants = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_Company)
    const [id, setID] = useState(NaN);

    useEffect(() => {
        if (idSelector)
            setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: number) => {
        setID(e);
        onChange(e);
    }

    const getLista = () => {
        instance.getAccountantIDLevelConstants(null).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <>
            <label>{label ?? "Mínimo nivel de registro contable"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const value = e.target.value ? Number(e.target.value) : null;
                setValue(value)
            }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.Value} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}